import styled, { css } from 'styled-components'

export const Logo = styled.div(() => {
  return css`
    font-family: 'Averia Libre';
    font-size: 38px;
  `
})
